import requests from '../../../../redux/reducer/requests';
import content from '../../../../redux/reducer/content';
import user from '../../../../redux/reducer/user';
import { useDispatch } from 'react-redux';

export default function useShopCallbacks() {
  const dispatch = useDispatch();

  return {
    getShopItems: () => dispatch(requests.thunks.shopItems()),
    buyItem: (id) => dispatch(requests.thunks.buyItem(id)),
    equipItem: (id) => dispatch(requests.thunks.equipItem(id)),
    getLootBoxesList: () => dispatch(requests.thunks.getLootBoxesList()),
    buyLootBoxById: (id) => dispatch(requests.thunks.buyLootBoxById(id)),
    setActiveLootBoxPrize: (lootBox) => dispatch(content.actions.setActiveLootBoxPrize(lootBox)),
    setPendingGachaReward: (reward) => dispatch(content.actions.setPendingGachaReward(reward)),
    collectPendingGachaReward: (pendingReward) => {
      if (!pendingReward?.openPayload) return false;

      dispatch(user.actions.applyPendingGachaReward(pendingReward.openPayload));
      dispatch(content.actions.clearPendingGachaReward());
      dispatch(requests.thunks.getLootBoxesList());
      return true;
    },
    setInteractiveShopBackground: (backgroundUrl) =>
      dispatch(content.actions.setInteractiveShopBackground(backgroundUrl)),
  };
}
